// extracted by mini-css-extract-plugin
module.exports = {"contactContainer":"styles__contactContainer___35AUH","name":"styles__name___2lj6y","preview":"styles__preview___2h7X1"};